import React from 'react'

export const getMaterialMasterDetailsTooltip = (materialDetails) => {
    const { productName, productSpecification, variantName, brandName, categoryName, renderHTML, UOMValue, UOM} = materialDetails

    let displayProdNameArr = []
    if(brandName){
        displayProdNameArr.push(brandName)
    }
    if(productName){
        displayProdNameArr.push(productName)
    }
    if(variantName){
        displayProdNameArr.push(variantName)
    }

    const displayProdName = displayProdNameArr.join(" - ")

    if(renderHTML){
        return (
            <div>
                <p className="m-0">{`${displayProdName} | ${productSpecification} ${UOM ? `| ${UOMValue ? UOMValue : '1'} * ${UOM}` : ''}`}</p>
                { categoryName ? <p className="m-0">{`category: ${categoryName}`}</p> : "" }
            </div>
        )
    } else {
        return `${displayProdName} | ${productSpecification} ${UOM ? `| ${UOMValue ? UOMValue : '1'} * ${UOM}` : ''} ${categoryName ? `\n Category: ` + categoryName : ""}`
    }
}

export const getPIVerificationStatusHTML = (sellerPIPunch) => {
    if(sellerPIPunch.verifiedBy){
        return <span className="text-teal-500">Verified</span>
    }
    else if(sellerPIPunch.skippedBy){
        return <span className="text-teal-500">Verification Skipped</span>
    }
    else{
        return <span className="text-red-600">Verification Pending</span>
    }
}

export const getMaterialMasterApproverTooltipHTML = (approvers, partialSpecsApprover, partialSpecsApprovalStatus) => {
    let partialSpecsApprovalText = ''
    if (partialSpecsApprover) {
        if (partialSpecsApprovalStatus === 12) {
            partialSpecsApprovalText = <span>RAISED to {partialSpecsApprover} for partial specs approval; </span>
        }
        else if (partialSpecsApprovalStatus === 8) {
            partialSpecsApprovalText = <span>REJECTED by {partialSpecsApprover} for partial specs approval; </span>
        }
    }

    return <>
        {<p className="m-0 p-0">{partialSpecsApprovalText}<span className="font-bold">Approver(s):</span> {approvers}</p>}
    </>
} 